/**
 * Mission 68 CREATION: detect whether the local player's general is aflame.
 * Uses player state when present; also scans actionLog (same source as fireball VFX).
 */

export function isExploreUnknownMission68(gameState) {
  return Number(gameState?.exploreUnknownMissionIndex) === 68;
}

/**
 * @param {object | null | undefined} gameState
 * @param {string | number | null | undefined} playerId
 * @param {object | null | undefined} [playerState]
 * @returns {boolean}
 */
export function isPlayerGeneralAflameInMission68(gameState, playerId, playerState) {
  if (!isExploreUnknownMission68(gameState) || playerId == null) {
    return false;
  }
  if (playerState?.isExploreUnknownAflame === true) {
    return true;
  }
  const st = gameState?.state;
  if (st) {
    const alt = st[String(playerId)] ?? st[playerId];
    if (alt?.isExploreUnknownAflame === true) {
      return true;
    }
  }
  const log = gameState?.actionLog;
  if (!Array.isArray(log)) {
    return false;
  }
  const pid = String(playerId);
  return log.some((entry) => {
    if (!entry) return false;
    if (entry.targetKind !== 'general') return false;
    if (String(entry.targetPlayerId) !== pid) return false;
    return entry.type === 'eu-creation-fireball-fired' || entry.type === 'eu-creation-aflame-tick';
  });
}
